import { Menu } from 'react-daisyui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';

import { ICalendar } from '@types';
import moment from 'moment';

export default function CalendarList({ calendar }: { calendar: ICalendar }) {
  return (
    <Menu>
      {calendar?.calendar_events?.map((event) => (
        <div
          className='w-full flex ml-4 mt-2'
          data-testid='calendar-events'
          key={event.calendar_id}
        >
          <FontAwesomeIcon
            icon={faCalendarDay}
            size='1x'
            className='text-zinc-100 w-6 mr-3 mt-1'
          />
          {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
          <div className='min-w-0 ml-2'>
            <div className='mb-1 overflow-hidden overflow-ellipsis'>
              {event.title}
            </div>
          </div>
          <div className='text-amber-500 ml-auto mr-3'>
            {moment(new Date(event.start.toString())).format('MMM DD, YYYY')}
          </div>
        </div>
      ))}
    </Menu>
  );
}
